<div class="work-order-edit-container p-10">

  <mat-tab-group [(selectedIndex)]="viewModel.selectedIndex" (selectedTabChange)="resetTemplate($event)">

    <mat-tab label="Dati generali">

      <ctm-general-data #generalDataComponent *ngIf="generalDataConfiguration"
        [configuration]="generalDataConfiguration" [creaPackagingButtonConfiguration]="creaPackagingButtonConfiguration"
        (onSubmit)="submit($event)"></ctm-general-data>

      <!-- In input mi aspetto la configurazione del button crea Packaging -->


    </mat-tab>

    <mat-tab [label]="(isQuotation ? 'RowQuotation' : 'RowWorkOrder') | translate "
      *ngIf="viewModel.masterDetail && movementManagerConfiguration && movementManagerConfiguration.visible">

      <ctm-movement-manager #movementManagerComponent
        [configuration]="movementManagerConfiguration"></ctm-movement-manager>

    </mat-tab>

    <ng-container *ngIf="viewModel.workOrderRowHandlingEnabled">

      <mat-tab [label]="'Order&Handlings' | translate" *ngIf="!isQuotation">

        <ctm-work-order-handlings [configuration]="workOrderHandlingsConfiguration"></ctm-work-order-handlings>

      </mat-tab>

      <mat-tab [label]="'Riepilogo'"
        *ngIf="workOrderSummaryConfiguration && workOrderSummaryConfiguration.visible && !isQuotation">

        <ctm-work-order-summary></ctm-work-order-summary>

      </mat-tab>

      <mat-tab [label]="'Magazzini/Packaging'"
        *ngIf="workOrderLocationConfiguration && workOrderLocationConfiguration.visible && !isQuotation">

        <ctm-work-order-location [configuration]="workOrderLocationConfiguration"></ctm-work-order-location>

      </mat-tab>

    </ng-container>

    <ng-container *ngIf="viewModel.masterDetail">

      <mat-tab [label]="'Gestione documenti'">

        <ctm-work-order-documents [configuration]="workOrderDocumentsConfiguration"></ctm-work-order-documents>

      </mat-tab>
    </ng-container>

    <ng-container *ngIf="viewModel.masterDetail && this.workOrderTaskTabConfiguration?.visible && !this.isQuotation">

      <mat-tab [label]="'Progetti'">

        <ctm-work-order-task [isQuotation]="this.isQuotation"></ctm-work-order-task>

      </mat-tab>
    </ng-container>

    <ng-container *ngIf="viewModel.masterDetail && this.workOrderEditTemplateConfiguration?.visible && this.isQuotation">

      <mat-tab [label]="'CustomTemplate' | translate">

        <ctm-work-order-edit-template [configuration]="this.workOrderEditTemplateConfiguration"
          #EDITOR></ctm-work-order-edit-template>

      </mat-tab>
    </ng-container>

    <ng-container *ngIf="viewModel.masterDetail && this.workOrderDynamicTabFormConfiguration?.visible">

      <mat-tab [label]="form.formGeneratorModel?.Title | translate"
        *ngFor="let form of this.workOrderDynamicTabFormConfiguration?.dynamicForms">
        <div class="work-order-dynamic-form-container">
          <ct-dynamic-form-generator #formGenerator [configuration]="form"></ct-dynamic-form-generator>
        </div>
      </mat-tab>

    </ng-container>


  </mat-tab-group>
  <div *ngIf="schedulerListConfiguration" class="ct-manager-master-detail-container">

    <app-scheduler-list *ngIf="schedulerListConfiguration"
      [schedulerListConfiguration]="schedulerListConfiguration"></app-scheduler-list>


  </div>

</div>
<ng-template #headerActions>

  <!-- Nuovo componente con menu avanzato (se enabled = true) -->
  <app-work-order-download-menu 
    *ngIf="workOrderDownloadMenuConfiguration && workOrderDownloadMenuConfiguration.enabled && viewModel.workOrder?.Oid"
    [configuration]="workOrderDownloadMenuConfiguration"
    [workOrderOid]="viewModel.workOrder.Oid">
  </app-work-order-download-menu>

  <!-- Componente legacy per compatibilità (se enabled = false o configurazione non presente) -->
  <app-lang-download-file 
    *ngIf="!workOrderDownloadMenuConfiguration || !workOrderDownloadMenuConfiguration.enabled"
    [configuration]="langDownloadFileConfiguration"
    (onDownload)="downloadPdf($event)">
  </app-lang-download-file>

  <!-- Bottone per aprire la modale dei log eventi del WorkOrder -->
  <ct-button *ngIf="eventLogButtonConfiguration.visible"
             [configuration]="eventLogButtonConfiguration"
             class="event-log-button">
  </ct-button>

</ng-template>
